import { render, staticRenderFns } from "./NewChatListItem.vue?vue&type=template&id=0f76ce97&scoped=true"
import script from "./NewChatListItem.vue?vue&type=script&lang=js"
export * from "./NewChatListItem.vue?vue&type=script&lang=js"
import style0 from "./NewChatListItem.vue?vue&type=style&index=0&id=0f76ce97&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f76ce97",
  null
  
)

export default component.exports